/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {apiUrl, handleApiCall, composeCommonQuery, securedApiOptions, getEnumParams} from './HttpUtils'

const getUsersApiUrl = (search, sort, sortOrder) => {
    return apiUrl(`users`) + composeCommonQuery(search, sort, sortOrder)
}

const getUserApiUrl = (userId) => {
    return apiUrl(`users/${userId}`)
}

export const fetchUsers = (search, sort, sortOrder, fleetIds, childFleetId, roles, levels, status = ['ACTIVE']) => {
    let query = ''
    query += getEnumParams('fleetIds', fleetIds)
    query += getEnumParams('roles', roles)
    if (levels) {
        query += '&levels=' + levels
    }
    if (childFleetId) {
        query += '&childFleetId=' + childFleetId
    }
    if (status) {
        if(Array.isArray(status)) {
            query += '&status=' + status.join('&status=')
        } else {
            query += '&status=' + status;
        }
    }
    return handleApiCall(getUsersApiUrl(search, sort, sortOrder) + query)
}

export const fetchUser = (userId) => {
    return handleApiCall(getUserApiUrl(userId))
}

export const updateUser = (user) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(
        user
    )

    return handleApiCall(getUserApiUrl(user.id), opts)
}

export const createUser = (user) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = JSON.stringify(
        user
    )

    return handleApiCall(apiUrl(`users`), opts)
}

export const fetchFleetManagers = () => {
    return handleApiCall(apiUrl(`users/fleetManager`))
}

export const deactivateUser = (userId) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(apiUrl(`users/deactivate/` + userId), opts)
}

export const reactivateUser = (userId) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(apiUrl(`users/reactivate/` + userId), opts)
}

export const anonymizeUserData = () => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(apiUrl("users/anonymizeUserData"), opts)
}